import { createListModalComponent } from 'factories/ListModal'
import Filter from 'containers/Suppliers/Select/Filter'

export default createListModalComponent({
  getStorageKey: (self) => 'selectSupplier',
  getSettingsType: (self) => 'selectSupplier',
  initialFilterDto: (self) => ({ active: 'Active' }),
})(Filter)
